// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"9063d6c5","453":"86a56f48","626":"1d194496"}[chunkId] + ".chunk.js";
};